<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="analyze-page template-padding" v-else-if="loaded" > 
        
        <div v-if="hasTrackingEnabled()" >
    
            <!--
            <overviewCards :passedAPPKEY="passedAPPKEY" ></overviewCards>
            -->

            <div class="row no-gutters " >

                <div class="col-12 col-md pt-1 pb-1" >

                    <!--
                    <span class="h3 font-900" style="line-height: 34px; margin-rigth: 15px" > Select dates:  </span>

                    <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" clear-button-icon="false" :shortcuts="shortcuts" placeholder="Select dates:" ></date-picker>
                    -->

                    <div class="row no-gutters justify-content-start flex-wrap-scroll" >
                        <div class="col-auto btn-transparent text-center mr-2 cursor-pointer border-gray pl-2 pr-2" v-for="(group, index) in groupTimeframes" @click="switchDates( group )" v-bind:class="{ ' active' : group.value == groupBy.value }" > {{ group.text }} </div>
                    </div>

                </div>

                <div class="col-12 col-md-auto text-md-right mt-3 mt-md-0" >

                    <span class="h3 font-900" style="line-height: 34px; margin-rigth: 15px" > Select dates:  </span>

                    <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" clear-button-icon="false" :shortcuts="shortcuts" placeholder="Select dates:" ></date-picker>

                </div>

            </div>


            <analyze contentType="overview" :parentPeriod="period" :passedAPPKEY="passedAPPKEY" ></analyze>


            <engagement contentType="overview" :parentPeriod="period" :passedAPPKEY="passedAPPKEY" ></engagement>

        </div>
        
        <div v-else-if="!hasTrackingEnabled()" >
        
            <div class="row no-gutters mt-5 text-center" >
                <div class="col-12" > 
                    
                    <div class="col-12 col-md-4 offset-md-4 mb-5" >
                        <img src="@/assets/images/welcome.png"  class="col-12 col-md-10 offset-md-1" /> 
                    </div>

                    <h1> WELCOME {{getUserEmail}} </h1>

                </div>
            </div>
        </div>

    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import helper from '@/helpers/helpers.js';

import analyzeToday from '@/components/analyzeToday.vue'    
import analyze from '@/templates/analyze/Attribution.vue'     
import engagement from '@/templates/analyze/Engagement.vue'     
import overviewCards from '@/components/overview-cards.vue'     
    
export default{
    name: "organizations",
    props:{
        passedAPPKEY:{ type : [String, Boolean], default: false }
    },
    components:{
        analyzeToday,
        analyze,
        engagement,
        overviewCards
    },
    data () {
        return {
            loaded : false,
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            shortcuts: [
                { 
                    text: 'Today', 
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('day').toDate();
                        let end = this.$moment(Date.now()).endOf('day').toDate();

                        let period = [ start, end ];
                        //console.log(period)
                        return period;
                    } 
                },
                {
                    text: 'Yesterday',
                    onClick: () => {
                        //let start = this.$moment( ).subtract(1,'d').format( "YYYY-MM-DD 00:00:00" )
                        //let end = this.$moment( ).subtract(1,'d').endOf('day').format( "YYYY-MM-DD 00:00:00" )
                        
                        let start = this.$moment( ).subtract(1,'day').toDate();
                        let end = this.$moment( ).subtract(1,'day').endOf('day').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 7 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(7,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'weeks').startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'weeks').endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('month').toDate();
                        let end = this.$moment(Date.now()).endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 30 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(30,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'months').startOf('month').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'months').endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 3 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(3,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 6 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(6,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
            ],
            
            groupTimeframes: [
                {"value": "today", "text": "Today" }, {"value": 'yesterday', "text": "Yesterday" }, {"value": 'last7', "text": "Last 7 days" }, {"value": 'last30', "text": "Last 30 days" }, {"value": 'thismonth', "text": "This month" }, {"value": 'lastmonth', "text": "Last month" }
            ],
            groupBy: {"value": "today", "text": "Today" },
        }
    },
    beforeCreate: function (){
    
    },
    mounted: function(){
        
        this.loaded = true;
        this.init_period()
        //this.getCurrentMonthStats()

        console.log( this.hasTrackingEnabled() )
        
    },
    methods: {
        init_period(start = this.$moment(Date.now()).startOf('day').format('D MMM YYYY'), end = this.$moment(Date.now()).endOf('day').format('D MMM YYYY') ){
            
            //let end = this.$moment(Date.now()).format('D MMM YYYY');
            //let start = this.$moment(Date.now()).subtract(7,'d').format('D MMM YYYY');
            
            this.period = [ start, end ];
            
            //this.getData()
            
            
        },
        switchDates( group ){
            this.groupBy = group
            
            let start, end
            if( group.value == 'today' ){
                start = this.$moment(Date.now()).startOf('day').format('D MMM YYYY');
                end = this.$moment(Date.now()).endOf('day').format('D MMM YYYY');
            }else
            if( group.value == 'yesterday' ){
                start = this.$moment( ).subtract(1,'d').format('D MMM YYYY');
                end = this.$moment( ).subtract(1,'d').endOf('day').format('D MMM YYYY');
            }else
            if( group.value == 'last7' ){
                start = this.$moment(Date.now()).subtract(7,'days').format('D MMM YYYY');
                end = this.$moment(Date.now()).format('D MMM YYYY');
            }else
            if( group.value == 'last30' ){
                start = this.$moment(Date.now()).subtract(30,'days').format('D MMM YYYY');
                end = this.$moment(Date.now()).format('D MMM YYYY');
            }else
            if( group.value == 'thismonth' ){
                start = this.$moment(Date.now()).startOf('month').format('D MMM YYYY');
                end = this.$moment(Date.now()).endOf('month').format('D MMM YYYY');
            }else
            if( group.value == 'lastmonth' ){
                start = this.$moment(Date.now()).subtract(1,'months').startOf('month').format('D MMM YYYY');
                end = this.$moment(Date.now()).subtract(1,'months').endOf('month').format('D MMM YYYY');
            }
            
            this.period = [ start, end ];
            //console.log( this.period )
            
        },
        
        getCurrentMonthStats(){
            
            //rgba(255, 99, 132, 1)
            let start, end
            start = this.$moment(Date.now()).startOf('month').format('D MMM YYYY');
            end = this.$moment(Date.now()).endOf('month').format('D MMM YYYY');
            
            let timezone = helper.getAccountTimezone()            
            start = moment.tz(start, 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            end = moment.tz(end, 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            
            //make request
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/analyze/stats/all-stats', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    "startDate":  start,
                    "endDate":  end,
                    "groupBy": 'day'
                } 
            })
            .then(resp => {
                console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.body    
                }
                
            })
            .then(function(sales){

                //this.chartLoaded = true
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            //make request
            
            
        },
        
        hasTrackingEnabled(  ){
            if( this.$store.getters.getLoggedInOrganizationToken ){
                let org = this.$store.getters.getLoggedInOrganizationToken 
                org = JSON.parse( atob( org ) )
                console.log(org)
                if( org.settings.tracking == true ){
                    return true
                }else{
                    return false
                }
                return org.settings
            }else{
                return false
            }
            
        },
        
    },
    computed:{
        getUserEmail(){
            return this.$store.getters.getUserEmail
        },
    },
}
</script>


<style lang="scss" >
    
    .tab-content{
        
    }
    
    .card-body{
        padding-left:0;
        padding-right:0;
    }

</style>


// WEBPACK FOOTER //
// src/templates/analyze/Overview-v2.vue